__turbopack_context__.v({
  "addButtonWrapper": "jlE4IG_addButtonWrapper",
  "availability": "jlE4IG_availability",
  "availabilityWrapper": "jlE4IG_availabilityWrapper",
  "container": "jlE4IG_container",
  "iconSectionWrapper": "jlE4IG_iconSectionWrapper",
  "iconSectionWrapperManipulationEnabled": "jlE4IG_iconSectionWrapperManipulationEnabled",
  "insideWrapper": "jlE4IG_insideWrapper",
  "quantityLimit": "jlE4IG_quantityLimit",
  "tabletContent": "jlE4IG_tabletContent",
  "tabletPricingWrapper": "jlE4IG_tabletPricingWrapper",
  "trashButton": "jlE4IG_trashButton",
  "webContent": "jlE4IG_webContent",
  "wrapper": "jlE4IG_wrapper",
});
